import { PaginatedDetailCard } from '../../../../components/ui/PaginatedDetailCard';
import { resolveDocument } from '../../utils/resolveEmployeeFields';
import type { IdentityDocument } from '../../employeeTypes';

type Props = {
  documents: IdentityDocument[];
  icon: React.ReactNode;
  iconBg: string;
  title: string;
  t: (k: string) => string;
  collapsible?: boolean;
  defaultExpanded?: boolean;
};

export function DocumentsCard({
  documents,
  icon,
  iconBg,
  title,
  t,
  collapsible,
  defaultExpanded,
}: Props) {
  return (
    <PaginatedDetailCard
      items={documents}
      resolveFields={resolveDocument}
      icon={icon}
      iconBg={iconBg}
      title={title}
      t={t}
      previousLabel={t('employeeDetail.sections.documentPrevious')}
      nextLabel={t('employeeDetail.sections.documentNext')}
      stretch
      collapsible={collapsible}
      defaultExpanded={defaultExpanded}
    />
  );
}
